<template><cloud-disk-sms-user-list failure-only /></template>
<script>
import CloudDiskSmsUserList from "../components/CloudDiskSmsUserList.vue";
export default {
  name: "CloudDiskSmsFailures",
  components: { CloudDiskSmsUserList },
};
</script>
